module.exports = function getResource(label, vars = []) {
    let resources = {
        openUntil: 'Ouvert jusqu’à ',
        closed: 'Fermé',
        storeHoursUnavailable: 'Heures d’ouverture non disponibles'
    };
    return resources[label];
};
